import React from 'react';

import { StyledIconButton } from './iconButton.style';

const IconButton = (props) => {
  const { text, icon, ...otherProps } = props;

  return (
    <StyledIconButton {...otherProps}>
      {icon}
      {text}
    </StyledIconButton>
  );
};
export default IconButton;
